import Xtc from './Xtc'

export default class XTbl {
  title;
  url;
  cols;
  opt;

  constructor(url, title) {
    this.url = url;
    this.title = title;
  }

  add(col) {
    if (!this.cols) {
      this.cols = [];
    }
    this.cols.push(col);
  }


  addOpt(col, slotEdit, slotDelete, ridEdit, ridDelete) {
    this.opt = new Xtc('opt', 'عملیات').noSort();
    this.opt.opt = true;
    this.opt.slotEdit = slotEdit;
    this.opt.slotDelete = slotDelete;
    this.cols.push(this.opt)
    return this;
  }


  hidePagination() {
    this._hidePageination = true;
    return this;
  }


  getSortFields() {
    return this.cols.filter((item) => item.__sorter)
  }

  hideSearch() {
    this._hidePageination = true;
    return this;
  }

  addExtraBtn(btn) {
    this._hidePageination = true;
    return this;
  }

  noSearch() {
    this._noSearch = true;
    return this;
  }

  noSettings() {
    this._noSettings = true;
    return this;
  }
}

